<template>
  <div class="opple-config-topBar">
    <div
      class="opple-config-topBar_selectAll"
      @click="selectAll"
    >
      {{ $t('findDevice.selectAll') }}
    </div>
    <div
      class="opple-config-topBar_delete"
      @click="onDeleteDevice"
    >
      <i
        v-if="isDeleteLoading"
        class="el-icon-loading"
      />
      <i
        v-else
        class="el-icon-delete"
      />
      {{ $t('findDevice.remove') }}
    </div>
    <div
      class="opple-config-topBar_add"
      @click="showDeviceDialog"
    >
      + {{ $t('adddevice.add') }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'OppleConfigTopBar',
  components: {
  },
  props: {
    isDeleteLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },

  computed: {

  },

  watch: {

  },

  mounted() {
    // this.deviceCardList = []
  },

  methods: {
    selectAll() {
      this.$emit('selectAll');
    },
    showDeviceDialog() {
      this.$emit('showDeviceDialog');
    },
    onDeleteDevice() {
      if (this.isDeleteLoading) return;
      console.log('onDeleteDevice onDeleteDevice');
      
      this.$emit('deleteDevice')
    }
  },
};
</script>

<style lang="scss">
.opple-config-topBar {
  display: flex;
  justify-content: flex-end;
  padding: 10px 10px 20px;
  align-items: center;

  &>div {
    margin-right: 20px;
    cursor: pointer;
  }

  &_delete {
    padding: 9px 15px;
    border: 1px solid #1B45A4;
    border-radius: 4px;
    color: #1B45A4;
  }

  &_selectAll {

  }
  &_delete{
    line-height: 0;
  }
}

</style>